import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30cd8c0d"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "modal__wrapper" }
const _hoisted_3 = { class: "modal__title" }
const _hoisted_4 = { class: "modal__btns" }

import {defineProps} from 'vue/dist/vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TaskModal',
  props: {
    title: {},
    id: {}
  },
  setup(__props: any) {

const props = __props;




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: props.id,
    class: "modal"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", _hoisted_3, _toDisplayString(props.title), 1),
      _createElementVNode("div", _hoisted_4, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ])
  ], 8, _hoisted_1))
}
}

})